module.exports = __webpack_public_path__ + "img/ring_y_e_1_0@2x.79104356.png";